import React, { Fragment } from 'react';
interface ProgressStepperProps {
  steps: string[];
  currentStep: number;
}
export const ProgressStepper: React.FC<ProgressStepperProps> = ({
  steps,
  currentStep
}) => {
  return <div className="w-full max-w-3xl mx-auto mb-8" data-id="element-15">
      <div className="flex items-center justify-between" data-id="element-16">
        {steps.map((step, index) => <Fragment key={index} data-id="element-17">
            {/* Step circle */}
            <div className="flex flex-col items-center" data-id="element-18">
              <div className={`flex items-center justify-center w-10 h-10 rounded-full border-2 ${index < currentStep ? 'bg-[#005a9e] border-[#005a9e] text-white' : index === currentStep ? 'bg-white border-[#005a9e] text-[#005a9e]' : 'bg-white border-gray-300 text-gray-400'}`} data-id="element-19">
                {index < currentStep ? <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-20">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-21" />
                  </svg> : <span data-id="element-22">{index + 1}</span>}
              </div>
              <span className={`mt-2 text-sm ${index <= currentStep ? 'text-[#005a9e] font-medium' : 'text-gray-500'}`} data-id="element-23">
                {step}
              </span>
            </div>
            {/* Connector line */}
            {index < steps.length - 1 && <div className={`flex-1 h-[2px] mx-2 ${index < currentStep ? 'bg-[#005a9e]' : 'bg-gray-300'}`} data-id="element-24" />}
          </Fragment>)}
      </div>
    </div>;
};